import { render, staticRenderFns } from "./InventoryRevenueReport.vue?vue&type=template&id=669b00a2&scoped=true"
import script from "./InventoryRevenueReport.vue?vue&type=script&lang=js"
export * from "./InventoryRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./InventoryRevenueReport.vue?vue&type=style&index=0&id=669b00a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b00a2",
  null
  
)

export default component.exports